// This component takes a test suite id and displays a filterable list
// of selectable tests.
// When a test is selected the onTestSelection is called and passes back the selected
// test as a TestInfo object.
class TestCaseListController {
    constructor(toastr, TestInfoServiceApi) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.testSuiteId) {
                this.testSuiteId = changes.testSuiteId.currentValue;
                this.testInfoForSuite(this.testSuiteId);
            }
        };
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.showAll = true;
                this.fullTestCases = [];
                this.testCases = [];
                this.testSuiteId = -1;
                this.selectedTest = {};
                this.isInitialized = true;
            }
        };
        this.toggleNoInfo = () => {
            this.showAll = !this.showAll;
            if (this.showAll) {
                // Show all tests
                this.testCases = this.fullTestCases;
            }
            else {
                // Filter down to the tests without information
                this.testCases = _.filter(this.fullTestCases, (item) => {
                    return item.TestCaseInfoChars === 0;
                });
            }
            this.selectTest(this.testCases[0]);
        };
        this.testInfoForSuite = (suiteId) => {
            this.TestInfoServiceApi.testInfoForSuite(suiteId).then((response) => {
                let testCaseList = response.data;
                this.testCases = testCaseList;
                this.fullTestCases = testCaseList;
                if (this.fullTestCases.length === 0) {
                    return;
                }
                // if (this.selectedTest.Id === 0) {
                this.selectTest(this.testCases[0]);
                return;
                // }
            });
        };
        this.toastr = toastr;
        this.TestInfoServiceApi = TestInfoServiceApi;
    }
    selectTest(test) {
        this.onTestSelection({ test: test });
        this.selectedTest = test;
    }
}
angular.module('app').component('testCaseList', {
    bindings: {
        onTestSelection: '&',
        testSuiteId: '<',
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/TestCases/test-case-list.tpl.html',
    controllerAs: 'vm',
    controller: TestCaseListController
});
